import { render, staticRenderFns } from "./RecordPreview.vue?vue&type=template&id=675be42c"
import script from "./RecordPreview.vue?vue&type=script&lang=js"
export * from "./RecordPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports